import {format as formatDate} from 'date-fns'
const SPEEDSIZE_PREFIX='https://sfycdn.speedsize.com/a0aebe60-8b13-4e95-8aca-b006a78ac89f/'

const renderArticle = (article, aspectRatio) => {
  return `
    <div class="fs-article-card">
      <a href="#snap-modal-${article.objectID}" data-article-id="${article.objectID}">
        <div class="fs-image" style="aspect-ratio: ${aspectRatio}">
          <img
            src="${SPEEDSIZE_PREFIX}${article.thumbnail.retina.replace('width=300', 'width=500')}"
            loading="lazy"
            alt="${article.title}"
            width="${article.thumbnail.width}"
            height="${article.thumbnail.height}"
          />
        </div>
        <div class="fs-text">
          <p class="fs-title">${article.title}</p>
          <p class="fs-date">${formatDate(article.date * 1000, 'yyyy.MM.dd')}</p>
        </div>
      </a>
    </div>
  `
}


const ArticleCardRenderer = () => {
  return {
    renderArticle: renderArticle
  }
}


export default ArticleCardRenderer
